module.exports = __webpack_public_path__ + "static/mobius-logo-b9ad2964afdcb791ca51bb8ce1e13105.png";